// extracted by mini-css-extract-plugin
export default {"header":"Branding_header__4FMbw","svg":"Branding_svg__lsbTv"};